function base() {
	initSmoothScrollAnimation();
	initPreviousReports();
	initTooltips();
	initRevealOnScrollAnimations();
	initCookies();
	initMenu();

	//newsletter
	function sendNewsletter(email) {
		document.querySelectorAll('.message')?.forEach((el) => el.remove());
		const button = $('.button-newsletter');
		$.ajax({
			type: 'GET',
			url: '/wp-json/fh/v1/send-newsletter',
			data: {
				'email': email,
			},
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce': fh_config.rest_nonce,
			},
			beforeSend: function () {
				button.attr('disabled', true);
			},
			success: function (response) {
				if (response.success) {
					button.attr('disabled', false);
					button.parent().parent().append(`<p class="message">${fhTranslate('wyslano')}</p>`);
				} else {
					button.attr('disabled', false);
					button.parent().parent().append(`<p class="message">${fhTranslate('nie_wyslano')}</p>`);
				}
			},
			error: function (response) {
				button.attr('disabled', false);
				button.parent().parent().append(`<p class="message">${fhTranslate('nie_wyslano')}</p>`);

				console.log(response);
			},
		});
	}

	document.querySelector('.button-newsletter')?.addEventListener('click', (e) => {
		e.preventDefault();
		const input = document.querySelector('.newsletter-email');
		input.classList.remove('error');
		if (input.value !== '') {
			sendNewsletter(input.value);
		} else {
			input.classList.add('error');
		}
	});

	const isLangSwitcherOpen = reactive(false);
	const languagesDropdown = document.querySelector('.languages');
	const languagesBtn = document.querySelector('.lang-button');
	isLangSwitcherOpen.listen((newValue) => {
		if (languagesDropdown) languagesDropdown.classList.toggle('open', newValue);
		if (languagesBtn) languagesBtn.classList.toggle('open', newValue);
	});
	languagesBtn?.addEventListener('click', () => {
		isLangSwitcherOpen.set((currentVal) => !currentVal);
	});

	clickedOutside('.language-switcher', () => {
		isLangSwitcherOpen.set(false);
	});
}
